// extracted by mini-css-extract-plugin
export var acitonButtons = "_g6-0";
export var additionalIcon = "_g6-f";
export var block = "_g6-1";
export var blockContent = "_g6-7";
export var blockDescription = "_g6-8";
export var blockIcon = "_g6-9";
export var blockTitle = "_g6-6";
export var border = "_g6-a";
export var center = "_g6-l";
export var edge = "_g6-b";
export var edgeLabel = "_g6-c";
export var edgePath = "_g6-d";
export var error = "_g6-e";
export var flowchart = "_g6-g";
export var flowchartContent = "_g6-h";
export var highlighted = "_g6-3";
export var hover = "_g6-4";
export var icon = "_g6-i";
export var left = "_g6-m";
export var navButton = "_g6-j";
export var navButtons = "_g6-k";
export var right = "_g6-n";
export var selected = "_g6-2";
export var small = "_g6-5";